import { AxiosError } from "axios";

export function getServerError(error: unknown, fieldMapping: { [key: string]: string } = {}) {
  if (error instanceof AxiosError && error.response) {
    const response = error.response.data;

    if (response.errors && response.errors.length > 0) {
      /*
        Some errors returned by the API will be generic like "This field cannot be blank."
        In those cases, we need to show the field that may be passed in the response.
      */
      let message = response.errors[0].message;

      if (response.errors[0].field) {
        const fieldName = response.errors[0].field;
        /* 
          To remove redundancy, check if the field name is already in the message. 
          If so, we don't want to add it again.
        */
        if (!message.toLowerCase().includes(fieldName.toLowerCase().replaceAll("_", " "))) {
          if (message.endsWith(".")) {
            message = `${message.slice(0, -1)} : ${fieldName}`;
          } else {
            message = `${message} : ${fieldName}`;
          }
        }

        // If the field is in the frontend->backend mapping, replace the name
        if (fieldName in fieldMapping) {
          message = message.replace(fieldName, fieldMapping[fieldName]);
        }
      }
      return message;
    }

    if (response.detail) {
      return response.detail;
    }

    return "An unknown error occurred.";
  } else {
    return "An unknown error occurred.";
  }
}
